const swiperRiders = new Swiper('.seen-on__contents', {
  loop: true,
  slidesPerView: 1.3,
  spaceBetween: 20,
  pagination: {
      el: '.seen-on__contents .swiper-pagination-col',
      clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 4,
    }
  }
});